export default __webpack_public_path__ + "static/media/alte-birebaum.b919ee2e.webp";